/**
 * Strip the `.cls`/`.trigger`/`.page` extension to get the bare Apex class name.
 * Shared everywhere a metadata filename is turned into a class name (active-editor
 * tracking, coverage-decoration matching, code actions) so the variants stay in
 * lockstep.
 */
const STRIPPABLE_EXTENSIONS = new Set(["cls", "trigger", "page"]);

export function bareClassName(name: string | null | undefined): string {
  const value = name || "";
  const dot = value.lastIndexOf(".");
  if (dot < 0) return value;
  if (STRIPPABLE_EXTENSIONS.has(value.slice(dot + 1).toLowerCase())) {
    return value.slice(0, dot);
  }
  return value;
}
